import { render, staticRenderFns } from "./SoccerScoresMatchTimeline.vue?vue&type=template&id=1f0613b8&"
import script from "./SoccerScoresMatchTimeline.vue?vue&type=script&lang=js&"
export * from "./SoccerScoresMatchTimeline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports